import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '../../LoadingIndicator';
import LazyPlaceholder from './LazyPlaceholder';
import s from './LoadingPlaceholder.scss';
/*
  So design wants the transfer between our placeholder and our comment box editor to be smoother. Their request
  was to remove the loading indicator completely, but that has potential UX problems if a user has a slow connection and we
  can't fetch the editor js chunk fast enough. So we reformat the loading indicator here to appear where the editor controls will
  eventually pop up.

  The ms I decided on was based on the research here: https://www.nngroup.com/articles/response-times-3-important-limits/
  TLDR: 100ms is breakpoint for something to be percieved by the average person as not instant/connected to their input.
*/
var LoadingPlaceholder = function () {
    var _a = useState(false), showLoader = _a[0], setShowLoader = _a[1];
    useEffect(function () {
        /*
          One more note: we give a 25ms window for the animation to have time to spin up, want to start giving
          that feedback before we hit that 100ms breakpoint
        */
        var timeout = setTimeout(function () { return setShowLoader(true); }, 75);
        return function () {
            clearTimeout(timeout);
        };
    }, [setShowLoader]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LazyPlaceholder, null),
        React.createElement(LoadingIndicator, { className: classnames(s['loader'], showLoader && s['shown']) })));
};
LoadingPlaceholder.displayName = 'LoadingPlaceholder';
export default LoadingPlaceholder;
//# sourceMappingURL=LoadingPlaceholder.js.map